// Shared entry-value casing. Never change email, URLs, passwords or numeric identifiers.
export function entryCase(field={},settings={}){
 if(!["text","textarea","au_full_address","au_postal_address","au_street","au_address"].includes(field.type||"text"))return "none";
 if(["proper","upper","none"].includes(field.text_case))return field.text_case;
 if(/(?:^|_)(?:account|invoice|reference|postcode|zip|state|region|code|token|password|email|url|abn)(?:_|$)/i.test(field.name||""))return "none";
 return ["proper","upper","none"].includes(settings.entry_case)?settings.entry_case:"proper";
}
export function caseText(value,mode){
 if(typeof value!=="string"||mode==="none")return value;
 if(mode==="upper")return value.toLocaleUpperCase();
 return value.toLocaleLowerCase().replace(/(^|[^\p{L}\p{M}\p{N}])([\p{L}])/gu,(_,gap,letter)=>gap+letter.toLocaleUpperCase());
}
export function entryValue(field,value,settings={}){
 const mode=entryCase(field,settings);
 if(["au_full_address","au_postal_address","au_street","au_address"].includes(field?.type)&&value&&typeof value==="object")
  return {...value,...Object.fromEntries(["line1","line2","suburb"].filter(k=>typeof value[k]==="string").map(k=>[k,caseText(value[k],mode)]))};
 return caseText(value,mode);
}
export function resetEntryDefault(schema){
 return {...schema,settings:{...(schema.settings||{}),entry_case:"proper"},
 fields:(schema.fields||[]).map(f=>f.text_case==="none"?{...f,text_case:"inherit"}:f)};
}
